import { Component} from '@angular/core';

@Component({
    selector: 'commitmentReason-main',
    templateUrl: './commitmentReason-main.tmpl.html'
})

export class CommitmentReasonMain {
    editMode: boolean = null; 

    public setVal(val:boolean) {
        this.editMode = val;  
    }
}
  